import React, { useEffect, useState } from 'react'
import "./search.css"
import {Button, createTheme, Tab, Tabs, TextField, ThemeProvider} from "@material-ui/core"
import {SearchOutlined} from "@material-ui/icons"
import axios from 'axios'
import SingleContent from "../../components/SingleContent/SingleContent"
import CustomPagination from '../../components/Pagination/CustomPagination'


const useStyles = (theme) => ({
  textField: {
    width: '90%',
    marginLeft: 'auto',
    marginRight: 'auto',            
    paddingBottom: 0,
    marginTop: 0,
    fontWeight: 500
  },
  input: {
    color: 'white'
  }
})

function Search() {
  const classes = useStyles()
  // states
  const [type, setType] = useState(0)  // value for this will be 0 or 1 for know which is selected movie or tv for request
  const [page, setPage] = useState(1)  // pagination
  const [searchText, setSearchText] = useState("")
  const [content, setContent] = useState([])
  const [numOfPages, setNumOfPages] = useState(1)

  useEffect(() => {
    // console.log(type)
    window.scroll(0, 0)
    fetchData()
  }, [type, page])

  const fetchData = () => {
    axios.get(`https://api.themoviedb.org/3/search/${type?"tv":"movie"}?api_key=${process.env.REACT_APP_API_KEY}&query=${searchText}&language=en-US&page=${page}`)
      .then(res => {
        // console.log(res.data)
        setContent(res.data.results)
        setNumOfPages(res.data.total_pages)
      })
      .catch(err => {
        console.log(err)
      })
  }

  const handleKeyPress = (e) => {
    // console.log(e.key)
    if(e.key==="Enter") {
      fetchData()
    }
  }

  return (
    <div className='page'>
      <div>
        <div className='search-form'>
          <TextField id="standard-basic" className='textfield'
            label="Movie" variant="standard" 
            color='primary'
            InputProps={{
              style: { color:"white", }
            }}
            onChange={(e) => setSearchText(e.target.value)} 
            onKeyPress={handleKeyPress}
          />
          <Button variant='contained' style={{marginLeft:10}}
              onClick={fetchData} >
            <SearchOutlined />
          </Button>
        </div>
        <Tabs value={type} indicatorColor='primary' textColor='primary'
          className='tabs'
          onChange={(e, newValue) => {
            setType(newValue)
            setPage(1)
          }} >
          <Tab label="Search Movies" style={{color:"white", width:"50%"}} />
          <Tab label="Search TV Series" style={{color:"white", width:"50%"}} />
        </Tabs>
      </div>
      <div className="movies">
        {content && content.map((movie, i) => {
          return <SingleContent key={i} movie={movie} />
        })}
      </div>
      {/* if movies not found */}
      {content.length === 0 && (
        <h2 className='not-found'>Movies Not Found</h2>
      )}
      {numOfPages > 1 && (
        <CustomPagination setPage={setPage} numOfPages={numOfPages} />
      )}
    </div>
  )
}

export default Search
